import styled from 'styled-components';
import spacing from '../../../../styles/spacing';

export const StyledContentWrapper = styled.div`
    padding: 0 ${spacing[12]} ${spacing[12]};
    user-select: none;
`;
